import { render } from "./banniere.vue?vue&type=template&id=d95445d4&scoped=true"
import script from "./banniere.vue?vue&type=script&lang=js"
export * from "./banniere.vue?vue&type=script&lang=js"

import "./banniere.vue?vue&type=style&index=0&id=d95445d4&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d95445d4"]])

export default __exports__